import {call, put, takeLatest} from 'redux-saga/effects';
import settingsActions from '../actions/settings.actions';
import SettingsApi from '../api/SettingsApi';
import {handleSagaError} from './utils/CommonUtils';

function* updateSettings(action) {
    const emptyFunction = () => {};
    try {
        const payoutFunc = action.payload.payout ? SettingsApi.updatePayoutAccount : emptyFunction;
        const payoutAccount = yield call(payoutFunc, action.payload.payout || {});
        yield put(settingsActions.updateSettingsSuccess(payoutAccount));
    } catch (e) {
        yield handleSagaError(e, settingsActions.updateSettingsFailed(e));
    }
}

function* fetchPayout() {
    try {
        const payoutAccount = yield call(SettingsApi.getPayoutAccount);
        yield put(settingsActions.getPayoutSuccess({payoutAccount}));
    } catch (e) {
        yield handleSagaError(e, settingsActions.getPayoutFailed(e));
    }
}

function* settingsSaga() {
    yield takeLatest(settingsActions.TYPES.UPDATE_SETTINGS, updateSettings);
    yield takeLatest(settingsActions.TYPES.GET_PAYOUT, fetchPayout);
}

export default settingsSaga;
